"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CellInput_1 = __importDefault(require("@Components/ViewWork/Table/ValidationCells/CellInput"));
const dropdown_options_1 = require("@Const/dropdown-options");
const lodash_1 = __importStar(require("lodash"));
const contexts_1 = require("@App/contexts");
const AlternativeTitlesTableInfo = () => {
    const { workStore, libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return [];
    }
    const workById = workStore.workById;
    const languageOptions = libStore.languages;
    const akaTitles = workDraftFromLocal.alternativeTitles;
    const akaTitlesFromWork = workDraftFromLocal.id && workDraftFromLocal.isComplete && workById ? workById.alternativeTitles : [];
    // MPOR-1684: See comment on ReviewWorkFormScene file for details on the currentAkaTitles.length line I added.
    const currentAkaTitles = akaTitlesFromWork ? (0, lodash_1.difference)(akaTitles, akaTitlesFromWork) : [];
    return (0, react_1.useMemo)(() => {
        const alternativeTitlesSource = akaTitlesFromWork ? currentAkaTitles : akaTitles;
        const rows = alternativeTitlesSource.map((data, index) => {
            var _a, _b;
            return ({
                removeCellIdentifier: '',
                removable: true,
                cells: [
                    react_1.default.createElement(CellInput_1.default, { defaultValue: data.title, readOnly: true, name: `rows[${index}].alternativeTitleName`, key: `${lodash_1.default.uniqueId()}.alternativeTitleName`, type: 'text' }),
                    react_1.default.createElement(CellInput_1.default, { defaultValue: data.titleType
                            ? (_a = dropdown_options_1.titleTypeOptions.find((option) => +option.id === data.titleType)) === null || _a === void 0 ? void 0 : _a.label
                            : null, readOnly: true, name: `rows[${index}].alternativeTitleType`, key: `${lodash_1.default.uniqueId()}.alternativeTitleType`, type: 'text' }),
                    react_1.default.createElement(CellInput_1.default, { defaultValue: data.languageCode
                            ? (_b = languageOptions.find((option) => +option.id === data.languageCode)) === null || _b === void 0 ? void 0 : _b.label
                            : null, readOnly: true, name: `rows[${index}].alternativeTitleLanguage`, key: `${lodash_1.default.uniqueId()}.alternativeTitleLanguage`, type: 'text' }),
                ],
            });
        });
        return [
            {
                headerRow: {
                    row: [{ text: 'Alternative Title' }, { text: 'Alternative Title Type' }, { text: 'Language' }],
                    removableCells: true,
                },
                rows: rows,
            },
        ];
    }, [akaTitlesFromWork, currentAkaTitles, akaTitles]);
};
exports.default = AlternativeTitlesTableInfo;
